module.exports = __webpack_public_path__ + "static/media/Facebook.28cf62e8.svg";